import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Is4upsMultiCarrierBannerComponent } from './is4ups-multi-carrier-banner.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [Is4upsMultiCarrierBannerComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
   exports: [Is4upsMultiCarrierBannerComponent]
})
export class Is4upsMultiCarrierBannerModule {

  showIS4UPSBanner:boolean=false;
 }
